// versionHooks.js - Custom hooks for version functionality
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadVersion } from ".";

export const useVersion = () => {
  const dispatch = useDispatch();
  const version = useSelector((state) => state.version);

  // Load version information
  const handleLoadVersion = useCallback(() => {
    return dispatch(loadVersion());
  }, [dispatch]);

  return {
    // State
    value: version.value.version,
    isLoading: version.loading,
    isLoaded: version.loaded,

    // Actions
    loadVersion: handleLoadVersion,
  };
};
